module.exports = "<svg id=\"e022b192-6faf-4179-af46-f0d44be9f217\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path d=\"M23.88.32A16.47,16.47,0,0,0,7.07,17a19.58,19.58,0,0,0,1.38,6.26c4.69,10.19,8.37,16,15.46,26.19,7.18-10.68,11.16-16.09,15.84-26.19a19.21,19.21,0,0,0,1-6.26A16.52,16.52,0,0,0,23.88.32Zm-.12,27.09A10.22,10.22,0,1,1,33.89,17.19,10.18,10.18,0,0,1,23.76,27.41Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Location.svg
// module id = hOR3
// module chunks = 1